import { type FC } from 'react';

import { SuggestionAttribute, type SuggestionSource } from '@zen/graphql/types.generated';

import { extractProposedText } from './helpers';
import { SuggestionPill } from './SuggestionPill/SuggestionPill';
import { SuggestionText } from './SuggestionText/SuggestionText';

interface SuggestionProps {
  id: string;
  onAccept: (id: string) => void;
  onReject: (id: string, reason: string) => void;
  proposedValue: string;
  sources: SuggestionSource[];
  targetAttribute: SuggestionAttribute;
  variant: 'pill' | 'text';
}

const Suggestion: FC<SuggestionProps> = (props) => {
  const { proposedValue, targetAttribute, id, onAccept, onReject, variant } = props;
  const proposedValueText = extractProposedText(proposedValue, targetAttribute);

  if (variant === 'pill')
    return <SuggestionPill id={id} onAccept={onAccept} onReject={onReject} proposedValueText={proposedValueText} />;

  if (variant === 'text')
    return <SuggestionText id={id} onAccept={onAccept} onReject={onReject} proposedValueText={proposedValueText} />;
};

export default Suggestion;
